import React from "react";

import { AirlinesDataProvider } from "../../../common/data/lookup-data-providers/AirlinesDataProvider";
import { LanguagesDataProvider } from "../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { FileRecordDetailsPageHeader } from "./header/FileRecordDetailsPageHeader";
import { FileRecordDetailsStateProvider } from "./hooks/FileRecordDetailsStateProvider";
import { FileRecordDetailsSection } from "./sections/info/FileRecordDetailsSection";

export const FileRecordDetailsPage = (): JSX.Element => {
    return (
        <LanguagesDataProvider>
            <AirlinesDataProvider>
                <FileRecordDetailsStateProvider>
                    <FileRecordDetailsPageHeader />
                    <FileRecordDetailsSection />
                </FileRecordDetailsStateProvider>
            </AirlinesDataProvider>
        </LanguagesDataProvider>
    );
};
